export const APP_NAME = "EDUMET";
export const API_BASE_URL = "";
export const UNAUTHENTICATED_ENTRY = "/auth";
export const AUTHENTICATED_ENTRY = "/dashboard";
